<template>
  <section class="location">
    <img src="../assets/graphics/blue-line.svg" alt="Divider line" class="divider-blue-ln">
    <div class="location__list" id="book">
      <div class="location__list--content container">
        <h1 class="location__title --list">Hotel <b>Reservations</b></h1>
        <p class="location__description">
          <b>Our room block at the Condado Vanderbilt is being reserved</b><br>
          Here are some alternative hotels where you can find a room within walking distance from the venue.
        </p>
        <div class="location__hotels">
          <div class="--single">
            <h1>Condado Vanderbilt (Conference Venue)</h1>
            <h2><a target="_blank" href="https://www.condadovanderbilt.com/specials?ds_rl=1250973&gclsrc=aw.ds#/booking/step-1?data=('hAhd!'condado-new'~a8dt*fs.~rAat!2~cn!0~cg.~al5po*co*gp!'011927SEQUIR'~rn6ry*rk*re.~rr*ss6ax!0~cy*ds!('p8ls*as*st*h8ee3)~my5s8c8ne3)*3~.4%5D3!null4!%5B5!false~6.)%5D~8e*As4('%01A86543.*_">
              Book Now
            </a></h2>
          </div>
          <div class="--single">
            <h1>La Concha Renaissance</h1>
            <h2><a target="_blank" href="https://www.marriott.com/search/findHotels.mi?recordsPerPage=40&destinationAddress.latitude=18.4571525&isInternalSearch=true&vsInitialRequest=false&searchType=InCity&destinationAddress.stateProvince=San+Juan&searchRadius=50&singleSearchAutoSuggest=Unmatched&missingcheckInDateMsg=Please+enter+a+check-in+date.&is-hotelsnearme-clicked=false&for-hotels-nearme=Near&missingcheckOutDateMsg=Please+enter+a+check-out+date.&pageType=advanced&destinationAddress.country=PR&collapseAccordian=is-hidden&singleSearch=true&destinationAddress.city=San+Juan&isTransient=true&destinationAddress.longitude=-66.0733963&initialRequest=true&ftid=0x8c036f39ad954ec1:0xc6f48736bb949bde&destinationAddress.destination=1077+Ashford+Avenue,+San+Juan,+Puerto+Rico,+00907&fromToDate=10/07/2026&fromToDate_submit=01/22/2027&fromDate=01/19/2027&toDate=01/22/2027&toDateDefaultFormat=01/22/2027&fromDateDefaultFormat=01/19/2027&flexibleDateSearch=false&isHideFlexibleDateCalendar=false&t-start=2027-01-19&t-end=2027-01-22&lengthOfStay=4&roomCountBox=1+Room&roomCount=1&guestCountBox=1+Adult+Per+Room&numAdultsPerRoom=1&childrenCountBox=0+Children+Per+Room&childrenCount=0&clusterCode=none&deviceType=desktop-web&view=list&flexibleDateSearchRateDisplay=false&isSearch=true&isRateCalendar=true&destinationAddress.location=1077+Ashford+Avenue,+San+Juan,+Puerto+Rico,+00907&destinationAddress.secondaryText=San+Juan,+PR&destinationAddress.mainText=San+Juan&isFlexibleDatesOptionSelected=false&numberOfRooms=1#/6/">
              Book Now
            </a></h2>
          </div>
          <div class="--single">
            <h1>The Tryst Beachfront Hotel</h1>
            <h2><a target="_blank" href="https://direct-book.com/properties/TheTrystCondadoBeachDIRECT?locale=en&_gads_gcid=731761819&_gads_gclabel=4ZV2CPGWq7MBEJuZ99wC&_gha_gcid=100233201&_gha_phid=14b85ec2-0b9d-4521-97dd-09e0681f925e&_src=DemandPlus&abw=26&booking_source=organic&campaign_id=&cdow=Tuesday&checkInDate=2025-01-21&checkOutDate=2025-01-24&country=FR&currency=USD&device=desktop&los=3&meta=Google&tsd=selected&utm_source=GoogleHotelAds&items[0][adults]=2&items[0][children]=0&items[0][infants]=0&items[0][rateId]=380009&trackPage=no">
              Book Now
            </a></h2>
          </div>
          <div class="--single">
            <h1>San Juan Marriott Resort & Stellaris Casino</h1>
            <h2><a target="_blank" href="https://www.marriott.com/en-us/hotels/sjupr-san-juan-marriott-resort-and-stellaris-casino/overview/">
              Book Now
            </a></h2>
          </div>
          <div class="--single">
            <h1>Condado Ocean Club</h1>
            <h2><a target="_blank" href="https://www.condadooceanclub.com/#/booking/step-1?data=('hChd!'condado-ocean'~aeA19dtA49fs.~rCat!2~cn!0~cg.~al8po3co3gp3rn.)Bry3rk3re.~rr*)Bax!0~cy3ds!('pe3ls3as3st*)~my8se3ce3ne*)*!null.7%5D3*~6%2F27!%5B8!false~96025'~A!'016B%5D~Cs7('%01CBA98763.*_">
              Book Now
            </a></h2>
          </div>
          <div class="--single">
            <h1>Holiday Inn Express: San Juan Condado</h1>
            <h2><a target="_blank" href="https://www.ihg.com/holidayinnexpress/hotels/us/en/find-hotels/select-roomrate?qDest=1%20Mariano%20Ramirez%20Bages,%20San%20Juan,%20PR&qPt=CASH&qCiD=21&qCoD=24&qCiMy=002025&qCoMy=002025&qAdlt=2&qChld=0&qRms=1&qRtP=IDAP0&qSlH=SJUPR&qAkamaiCC=MX&srb_u=1&qExpndSrch=false&qSrt=sBR&qBrs=6c.hi.ex.sb.ul.ic.cp.cw.in.vn.cv.rs.ki.kd.ma.sp.va.sp.re.vx.nd.sx.we.lx.rn.sn.sn.sn.sn.sn.nu&qWch=0&qSmP=0&qRad=30&qRdU=mi&setPMCookies=false&qpMbw=0&qErm=false&qpMn=0&qLoSe=false&qChAge=&qRmFltr=">
              Book Now
            </a></h2>
          </div>
          <div class="--single">
            <h1>Hilton Garden Inn San Juan Condado</h1>
            <h2><a target="_blank" href="https://www.hilton.com/en/book/reservation/rooms/?ctyhocn=SJUSJGI&arrivalDate=2025-01-21&departureDate=2025-01-24&room1NumAdults=1&displayCurrency=USD">
              Book Now
            </a></h2>
          </div>
          <div class="--single">
            <h1>More options around the area</h1>
            <h2><a target="_blank" href="https://www.google.com/maps/place/Condado+Vanderbilt+Hotel/@18.4587465,-66.0820279,16z/data=!3m1!5s0x8c036f397d30c3df:0xde55989c50e9bb76!4m22!1m9!2m8!1sHotels!5m5!5m4!1s2025-01-21!2i3!4m1!1i2!6e3!3m11!1s0x8c036f3bd671632d:0xb6837a09f0274c9b!5m4!1s2025-01-21!2i3!4m1!1i2!8m2!3d18.458747!4d-66.0760833!15sCgZIb3RlbHOSAQVob3RlbOABAA!16s%2Fm%2F0641vlb?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoASAFQAw%3D%3D">
              Find Hotel
            </a></h2>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/location.scss';
</style>

<script>

export default {
  name: 'location',
  components: {
    
  },
  data() {
    return {
    };
  },
};
</script>